export enum RequirementCategory {
  AOG = "AOG",
  Scheduled = "SCHEDULED",
  ScheduledMaintenance = "SCHEDULED BASE MAINTENANCE",
  Redelivery = "REDELIVERY",
  Replenishment = "REPLENISHMENT",
  ReplenishmentCustomerAsset = "REPLENISHMENT CUSTOMER ASSET",
  ReplenishmentCustomerAssetAog = "REPLENISHMENT CUSTOMER ASSET AOG",
  ReplenishmentHomebase = "REPLENISHMENT HOMEBASE",
  MockInitialHbk = "MOCK/INITIAL HBK",
  Normalization = "NORMALIZATION",
  ReturnHbk = "RETURN HBK",
  ReplenishmentHomebaseAog = "REPLENISHMENT HOMEBASE AOG",
  ScheduledModification = "SCHEDULED MODIFICATION",
  ScheduledLeaseReturnMaintenance = "SCHEDULED LEASE RETURN MAINTENANCE",
  ScheduledBaseMaintenance = "SCHEDULED BASE MAINTENANCE",
  ScheduledHardTime = "SCHEDULED/HARD TIME",
  StandartExchange = "STANDART EXCHANGE",
  ReplenishmentNonExHbk = "REPLENISHMENT NON-EX HBK",
  CategoryD = "CATEGORY D",
  CategoryC = "CATEGORY C",
  CategoryB = "CATEGORY B",
  CategoryA = "CATEGORY A",
  Routine = "ROUTINE",
  Expedite = "EXPEDITE",
  Critical = "CRITICAL",
  CageReplenishment = "CAGE_REPLENISHMENT",
  DafzaReplenishment = "DAFZA_REPLENISHMENT",
  DafzaPriorityReplenishment = "DAFZA_PRIORITY_REPLENISHMENT",
}
export const HomeBaseReplenishmentArray = [
  RequirementCategory.ReplenishmentHomebase,
  RequirementCategory.ReplenishmentHomebaseAog,
  RequirementCategory.ReplenishmentCustomerAsset,
  RequirementCategory.ReplenishmentCustomerAssetAog,
];
export const HomeBaseReplenishmentArrayForQty = [
  RequirementCategory.ReplenishmentHomebase,
  RequirementCategory.ReplenishmentHomebaseAog,
];

export const IncludeHomeBaseReplenishmentArray = [RequirementCategory.MockInitialHbk];

export const MelCategoryRequiredArray = [
  RequirementCategory.AOG,
  RequirementCategory.CategoryA,
  RequirementCategory.CategoryB,
  RequirementCategory.CategoryC,
  RequirementCategory.CategoryD,
  RequirementCategory.Routine,
  RequirementCategory.Critical,
  RequirementCategory.Expedite,
];

export const HomeBaseCategories = [
  RequirementCategory.ReplenishmentHomebase,
  RequirementCategory.ReplenishmentCustomerAsset,
];

export default RequirementCategory;
